import { ReactNode } from 'react';
import { TypeOptions, toast, ToastOptions, ToastContentProps } from 'react-toastify';

import { MultiLinerToast, OneLinerToast } from './ToastContainer';

type ToastContent =
  | string
  | {
      readonly children: ReactNode;
      readonly title?: ReactNode;
      readonly className?: string;
    };

interface ToastWrapperProps extends Partial<ToastContentProps> {
  readonly type: TypeOptions;
  readonly content: ToastContent;
}

function ToastWrapper({ type, content, ...props }: ToastWrapperProps) {
  if (typeof content === 'string') {
    return (
      <OneLinerToast type={type} {...props}>
        {content}
      </OneLinerToast>
    );
  }

  const { title, children, className } = content;

  return (
    <MultiLinerToast type={type} title={title} className={className} {...props}>
      {children}
    </MultiLinerToast>
  );
}

const Toast = {
  info(content: ToastContent, options?: ToastOptions) {
    toast.info(<ToastWrapper type="info" content={content} />, options);
  },
  success(content: ToastContent, options?: ToastOptions) {
    toast.success(<ToastWrapper type="success" content={content} />, options);
  },
  error(content: ToastContent, options?: ToastOptions) {
    toast.error(<ToastWrapper type="error" content={content} />, options);
  },
  warning(content: ToastContent, options?: ToastOptions) {
    toast.warning(<ToastWrapper type="warning" content={content} />, options);
  },
  dismiss(id?: string) {
    toast.dismiss(id);
  },
};

export { Toast as toast };
